<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link :to="`/certificateapplys/${ceractiveName}/${pageIndex}`">
                    <i class="el-icon-arrow-left" style="cursor: pointer;"></i>
                    操作证查看 / 证书详情
                    </router-link>
					
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="purchasesee-box">
            <p class="purchasesee-title">用户信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item1">
                    <li>姓名:{{seecerApplylist.ownerName}}</li>
                    <li>性别:{{seecerApplylist.ownerSex}}</li>
                    <!-- <li>身份证号:{{seecerApplylist.ownerIdentityCards}}</li> -->
                    <li>联系电话:{{seecerApplylist.ownerCellphoneNumber}}</li>
                </ul>
                <ul class="seelicense-item1">
                    <li>地区:{{seecerApplylist.provinceName}}{{seecerApplylist.cityName}}</li>
                    <li>学历:{{seecerApplylist.ownerEducationDegree}}</li>
                    <li>身份证号:{{seecerApplylist.ownerIdentityCards}}</li>
                </ul>
                <ul class="seelicense-itemphoto" v-if="seecerApplylist.ownerIdentityCardsPhoto">
                    <li>身份证照片:</li>
                    <li v-for="item in seecerApplylist.ownerIdentityCardsPhoto">
                        <img :src="'/api/static'+item" alt />
                    </li>
                </ul>

                <ul class="seelicense-itemphoto" v-if="seecerApplylist.ownerCredentialsPhoto">
                    <li>证件照片:</li>
                    <li>
                        <img :src="'/api/static'+seecerApplylist.ownerCredentialsPhoto" alt />
                    </li>
                </ul>

                <!-- <ul class="seelicense-item5">
					<li>车主:{{seecerApplylist.ownerName}}</li>
					<li>身份证号:{{seecerApplylist.ownerIdentityCards}}</li>
					<li>联系电话:{{seecerApplylist.ownerCellphoneNumber}}</li>
				</ul>
				<p class="seelicense-item2">
					地址:{{seecerApplylist.shippingAddress}}
                </p>-->
            </div>
            <p class="purchasesee-title">基本信息</p>
            <div class="purchasesee-padding">
                <ul class="seelicense-item3">
                    <li>证书编码：{{seecerApplylist.operationCertificateNumber}}</li>
                    <li>申请时间: {{seecerApplylist.createTimeStr}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>姓名：{{seecerApplylist.ownerName}}</li>
                    <li>身份证号: {{seecerApplylist.ownerIdentityCards}}</li>
                </ul>

                <ul class="seelicense-item3">
                    <li>操作项目：{{seecerApplylist.operationItems}}</li>
                    <li>有效起止日期: {{seecerApplylist.validDate}}</li>
                </ul>
                <ul class="seelicense-item3">
                    <li>培训起止日期：{{seecerApplylist.studyDate}}</li>
                    <li
                        v-if="seecerApplylist.isFirst != undefined &&seecerApplylist.isFirst == 2"
                    >本证属：换发 岗龄{{seecerApplylist.workAge}}年</li>
                    <li v-else>本证属：初次颁发 岗龄{{seecerApplylist.workAge}}年</li>
                </ul>
            </div>
            <p class="purchasesee-title" v-if="seecerApplylist.shippingAddress">邮寄地址</p>
            <div class="purchasesee-padding">
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingName"
                >收货人姓名: {{seecerApplylist.shippingName}}</p>
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingCellphoneNumber"
                >收货人手机号: {{seecerApplylist.shippingCellphoneNumber}}</p>
                <p
                    class="seelicense-item5"
                    v-if="seecerApplylist.shippingAddress"
                >收货地址: {{seecerApplylist.shippingAddress}}</p>
            </div>
        </div>

        <div class="bottomBtn">
            <p style="margin-top: 20px;">
                <el-button type="primary" icon @click="cerEdit('cereditform')">修改信息</el-button>
            </p>
            <!-- 新增内容修改 -->
            <p style="margin:20px 0 0 20px">
                <el-button type="primary" icon @click="isRenewal()">到期换证</el-button>
            </p>
        </div>
        <!-- 新增到期换证确认弹窗 -->
        <el-dialog title :visible.sync="ishow" width="30%" :show-close="isClose">
            <span>是否确定到期换证</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ishow = false">取 消</el-button>
                <el-button type="primary" @click="jumpEndList">确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 修改信息弹窗 -->
        <el-dialog class="branch-dialog" title="编辑证书" :visible.sync="cereditVisible" width="600px">
            <el-form ref="cereditform" :model="cereditform" :rules="cereditrules">
                <el-form-item label="区域" prop="provinceId">
                    <el-select
                        v-model="cereditform.provinceId"
                        placeholder="请选择省份"
                        @change="provinceChange(cereditform)"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in provinceOptions"
                            :key="item.provinceId"
                            :label="item.name"
                            :value="item.provinceId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label prop="cityId">
                    <el-select
                        v-model="cereditform.cityId"
                        placeholder="请选择市区"
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="item in citysOptions"
                            :key="item.cityId"
                            :label="item.name"
                            :value="item.cityId"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="姓名" prop="ownerName">
                    <el-input v-model="cereditform.ownerName"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                    <el-radio-group v-model="cereditform.ownerSex">
                        <el-radio label="1">男</el-radio>
                        <el-radio label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="文化程度" prop="ownerEducationDegree">
                    <el-input v-model="cereditform.ownerEducationDegree"></el-input>
                </el-form-item>

                <el-form-item label="操作项目" prop="operationItems">
                    <el-input v-model="cereditform.operationItems"></el-input>
                </el-form-item>
                <!-- 手机号 -->
                <el-form-item label="手机号" prop="ownerCellphoneNumber">
                    <el-input v-model="cereditform.ownerCellphoneNumber"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="ownerIdentityCards">
                    <el-input v-model="cereditform.ownerIdentityCards"></el-input>
                </el-form-item>
                <!-- 图片上传 -->
                <el-form-item label="添加照片" prop="ownerCredentialsPhoto">
                    <el-upload
                        class="avatar-uploader avatar-box"
                        action="#"
                        :show-file-list="false"
                        :http-request="uploadAvatar"
                        :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="imageUrl" :src="'/api/static'+imageUrl" class="avatar" />
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cerEditSave('cereditform')">确 定</el-button>
                <el-button @click="cereditVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    listProvinces,
    getCertificateApply,
    listCitysByProvinceId,
    getUpdatePcCertificateApply,
    updatePcCertificateApply,
    endChange
} from '@/api/index';
export default {
    name: 'cerapplyseesec',
    data() {
        var validPhone = (rule, value, callback) => {
            // debugger
            const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
            if (!value) {
                return callback(new Error('电话号码不能为空'));
            } else if (!Number.isInteger(+value)) {
                callback(new Error('请输入数字值'));
            } else {
                if (phoneReg.test(value)) {
                    callback();
                } else {
                    callback(new Error('电话号码格式不正确'));
                }
            }
        };
        var validIdNum = (rule, value, callback) => {
            const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (!value) {
                return callback(new Error('证件号码不能为空'));
            } else if (!reg.test(value)) {
                return callback(new Error('证件号码不正确'));
            } else {
                callback();
            }
        };
        return {
			ceractiveName:'',
			pageIndex:'',
            provinceOptions: [], //省列表
            citysOptions: [], //市列表
            certificateApplyId: '',
            seecerApplylist: {}, //查看
            cereditVisible: false,
            ishow: false,
            isClose: false,
            cereditform: {
                // provinceId:'',
                // cityId:'',
                // ownerName:'',
                // ownerCellphoneNumber:'',
                // ownerSex:'1',
                // ownerEducationDegree:'',
                // operationItems:'',
                // ownerIdentityCards:'',
                // ownerIdentityCardsPhoto:'',
            },

            imageUrl: '',
            cereditrules: {
                provinceId: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
                cityId: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
                ownerName: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
                ownerCellphoneNumber: [{ required: true, validator: validPhone, trigger: ['blur', 'change'] }],
                operationItems: [{ required: true, message: '请输入操作项目', trigger: ['blur', 'change'] }],

                ownerIdentityCards: [{ required: true, validator: validIdNum, trigger: ['blur', 'change'] }]
            } //添加表单验证
        };
    },
    created() {
        this.certificateApplyId = this.$route.params.certificateApplyId;
		this.ceractiveName = this.$route.params.ceractiveName;
		this.pageIndex = this.$route.params.pageIndex;
		
        // 查看
        getCertificateApply(
            {},
            {
                certificateApplyId: this.certificateApplyId
            }
        ).then(res => {
            this.seecerApplylist = res.data;
            if (res.data.ownerIdentityCardsPhoto) {
                this.seecerApplylist.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(',');
            }
        });
    },
    methods: {
        // 新增判断是否要变更弹窗
        isRenewal() {
            this.ishow = true;
        },
        // // 关闭变更挂盘提醒
        //     closeIsshow(){

        //     },
        // 跳转到期换证审核列表
        jumpEndList() {
            this.ishow = false;
            console.log(this.seecerApplylist.certificateApplyId);
            endChange({ certificateApplyId: this.seecerApplylist.certificateApplyId }).then(res => {
                
				this.$message({
				          message: '已成功提交换证申请',
				          type: 'success'
				        });
				// this.$router.push('/operationhistory/checksecond') 跳到操作证审核页面
				// this.$router.push('`/fzorgancertificateapplys/${this.ceractiveName}/${this.pageIndex}`');
				this.$router.push('/fzorgancertificateapplys/'+ this.ceractiveName +'/'+ this.pageIndex);
				
		
            });
        },
        // 省改变请求市
        provinceChange(Licenselyform) {
            Licenselyform.cityId = '';
            listCitysByProvinceId({
                provinceId: Licenselyform.provinceId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.citysOptions = res.data;
            });
        },
        cerEdit(formName) {
            // 省
            listProvinces({}).then(res => {
                // 获取数据成功后的其他操作
                this.provinceOptions = res.data;
            });
            // 回显列表
            getUpdatePcCertificateApply(
                {},
                {
                    certificateApplyId: this.certificateApplyId
                }
            ).then(res => {
                this.cereditform = res.data;
                this.cereditform.ownerSex = res.data.ownerSex + '';
                this.imageUrl = res.data.ownerCredentialsPhoto;
                listCitysByProvinceId({
                    provinceId: res.data.provinceId
                }).then(res => {
                    // 获取数据成功后的其他操作
                    this.citysOptions = res.data;
                });
            });
            this.cereditVisible = true;
        },

        // 总部添加证书
        uploadAvatar(item) {
            const _file = item.file;
            var formData = new FormData();
            formData.append('file', _file);
            this.$http({
                method: 'post',
                headers: { 'Content-Type': 'multipart/form-data' },
                url: '/api/homepage/uploadImages',
                data: formData,
                crossDomain: true,
                cache: false
            })
                .then(res => {
                    this.imageUrl = res.data.data[0];
                })
                .catch(() => {
                    this.$message.error('上传失败，请重新上传');
                });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPng = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPng) {
                this.$message.error('上传图片只能是 JPG或png 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return (isJPG || isPng) && isLt2M;
        },

        cerEditSave(formName) {
            if (this.imageUrl) {
                this.cereditform.ownerCredentialsPhoto = this.imageUrl;
            } else {
                this.$message.error('请上传照片!');
                return false;
            }

            this.$refs[formName].validate(valid => {
                if (valid) {
                    updatePcCertificateApply(this.cereditform).then(res => {
                        if (res.code == 0) {
                            // 获取数据成功后的其他操作
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            var organizationKind = localStorage.getItem('organizationKind');
                            if (organizationKind == 2) {
                                // this.$router.push('/certificateapplys');
                            } else {
                                // 分支
                                // this.$router.push('/fzorgancertificateapplys');
                            }

                            this.cereditVisible = false;
                        } else if (res.code == 1) {
                            this.$message({
                                message: res.message,
                                type: 'warning'
                            });
                        } else {
                            this.$message({
                                message: '报错啦!',
                                type: 'warning'
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
/* 新增 */
.bottomBtn {
    display: flex;
}
.purchasesee-box {
    background: #fff;
    padding: 20px 0;
}
.purchasesee-title {
    height: 30px;
    line-height: 30px;
    background: #f0f0f0;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    border-left: 5px solid #437af4;
    text-indent: 30px;
}
.purchasesee-padding {
    padding: 20px 0;
}
.seelicense-item1 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 20px;
}
.seelicense-item1 li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-item1 li:last-child {
    flex: 1;
}
.seelicense-itemphoto {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 35px;
    color: #666;
}
.seelicense-itemphoto li {
    width: 200px;
    margin-right: 20px;
}
.seelicense-itemphoto li:first-child {
    width: 100px;
}
.seelicense-itemphoto li img {
    width: 100%;
}
.seelicense-item2 {
    padding: 0 35px;
    margin-top: 15px;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item3 {
    display: flex;
    display: -webkit-flex;
    padding: 0 35px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.seelicense-item3 li {
    width: 350px;
}
.seelicense-item4 {
    margin: 0 35px;
    background: #f8f8fb;
    padding: 20px;
    list-style: none;
    color: #666;
    letter-spacing: 1px;
}
.seelicense-item4 li {
    margin-bottom: 10px;
}

.seelicense-item5 {
    padding-left: 35px;
    height: 32px;
    line-height: 32px;
    letter-spacing: 1px;
    color: #666;
}

.purchasesee-text1,
.purchasesee-text2 {
    height: 32px;
    line-height: 32px;
    text-indent: 15px;
}

.purchasesee-text2 {
    text-indent: 50px;
}
.purchasesee-table {
    width: 50%;
    margin: 10px 0 30px 50px;
}
.purchasesee-linceinfo {
    margin: 10px 50px;
    display: flex;
    display: -webkit-flex;
}
.purchasesee-linceitem {
    width: 30%;
}
.purchasesee-linceitem:nth-child(2) {
    margin: 0 3%;
}

.organ-box {
    margin-bottom: 20px;
    text-align: right;
}
.apply-box {
    display: flex;
    display: -webkit-flex;
}
.apply-box p {
    flex: 1;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.branch-dialog .el-dialog__header {
    background: #409eff;
    padding: 10px 20px;
}
.branch-dialog .el-dialog__header .el-dialog__title {
    color: #fff;
}
.branch-dialog .el-dialog__header .el-dialog__headerbtn {
    background: #409eff;
    top: 12px;
}
.branch-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
}
.branch-dialog .el-dialog__body {
    height: 50vh;
    overflow-y: scroll;
    padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label {
    width: 100px;
}
.branch-dialog .el-form-item__content {
    margin-left: 100px;
}
.select-width .el-select {
    width: 100%;
}
</style>